import styled from "styled-components";

import banner from "../../images/3.jpg";
export const LoanCalculatorWrapper = styled.div`
  margin-top: 20px;
  & > div {
    flex: 1 1 45%;
    gap: 40px;
  }
  .left {
    display: flex;
    // background: #4FA0FF; /* Sky Blue background */
    margin-left: -110px;
    margin-right: 20px;
    // padding: 20px;
    // color: #1D3557; /* Dark Blue text */
    background-position: center;
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(79, 160, 255, 0.3);
    & > div {
      align-self: flex-end;
    }
    .img {
      img {
        width: 100% !important;
      }
    }
    p {
      font-weight: 600;
      font-size: 18px;
      line-height: 1.6;
    }
  }

  .selectLoanPurpose {
    padding: 11px !important;
    height: 50px !important;
    color: #1D3557; /* Dark Blue text */
    background: #FFFFFF; /* Clean White background */
    border: 2px solid #E5E5E5; /* Cool Gray border */
    border-radius: 8px;
    font-weight: 500;
    
    &:focus {
      border-color: #4FA0FF; /* Sky Blue on focus */
      outline: none;
      box-shadow: 0 0 0 3px rgba(79, 160, 255, 0.1);
    }
  }
  
  .right {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .box {
      padding: 23px 25px;
      background: #FFFFFF; /* Clean White background */
      box-shadow: 0px 4px 15px rgba(29, 53, 87, 0.1); /* Dark Blue shadow */
      border: 2px solid #E5E5E5; /* Cool Gray border */
      border-radius: 15px;
      min-height: 100px;
      // color: #1D3557; /* Dark Blue text */
      transition: all 0.3s ease;
      
      &:hover {
        box-shadow: 0px 6px 20px rgba(79, 160, 255, 0.15);
        border-color: #4FA0FF; /* Sky Blue on hover */
      }
      
      h2 {
        color: #1D3557; /* Dark Blue */
        margin-bottom: 10px;
        font-weight: 600;
      }
      
      & > div {
        gap: 12px;
        .value {
          font-size: 20px;
          font-weight: 700;
          color: #4FA0FF; /* Sky Blue */
        }
      }
    }
    
    .cards {
      display: flex;
      gap: 15px;
      margin: 15px 0;
      
      .card {
        background: #FFFFFF; /* Clean White */
        box-shadow: 0px 4px 15px rgba(79, 160, 255, 0.1); /* Sky Blue shadow */
        border: 2px solid #E5E5E5; /* Cool Gray border */
        border-radius: 12px;
        padding: 20px;
        text-align: center;
        flex: 1 1 30%;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-3px);
          box-shadow: 0px 8px 25px rgba(79, 160, 255, 0.2);
          border-color: #4FA0FF; /* Sky Blue on hover */
        }
        
        img {
          height: 50px;
          text-align: center;
          margin-bottom: 15px;
          padding: 8px;
          background: #4FA0FF; /* Sky Blue background for icons */
          border-radius: 10px;
        }
        
        h3 {
          font-size: 13px;
          color: #1D3557; /* Dark Blue */
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 8px;
        }
        
        h2 {
          font-size: 18px;
          color: #4FA0FF; /* Sky Blue */
          font-weight: 700;
          margin: 0;
        }
      }
    }
  }

  /* Range Slider Custom Styles */
  .range-slider {
    .track {
      background: #E5E5E5; /* Cool Gray */
      height: 6px;
      border-radius: 3px;
    }
    
    .thumb {
      background: #4FA0FF; /* Sky Blue */
      height: 20px;
      width: 20px;
      border-radius: 50%;
      box-shadow: 0 2px 6px rgba(79, 160, 255, 0.4);
      
      &:hover {
        background: #3A8CE6;
        box-shadow: 0 0 0 8px rgba(79, 160, 255, 0.2);
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .left {
      display: none;
    }
    .right {
      margin-inline: auto;
    }
  }
`;